import { render, staticRenderFns } from "./pnlReport.vue?vue&type=template&id=32507600&"
import script from "./pnlReport.vue?vue&type=script&lang=js&"
export * from "./pnlReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports